import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: 'Acesso Rápido',
      links: [
        { label: 'Entrar', to: '/app/login' },
        { label: 'Criar Conta', to: '/app/register' },
        { label: 'Eventos', to: '/app/events' },
        { label: 'Ranking', to: '/app/ranking' }
      ]
    },
    {
      title: 'Suporte',
      links: [
        { label: 'Regras do Clã', href: 'https://docs.google.com/document/d/e/2PACX-1vQsm_jIpGoTRYFukqA3aPiDxR-B0DsIQYP3mt5dOBnBgifBsOiFkDaNq0b0vsHRA_MeoimzZikel48C/pub' },
        { label: 'Contato', href: 'https://wa.me/5505198200861?text=Ol%C3%A1%20vim%20pelo%20Site%20da%20Revolution' },
        { label: 'Reportar Problema', href: 'https://wa.me/55044997605391?text=Ol%C3%A1%20encontrei%20um%20problema%20no%20site%20da%20Revolution' }
      ]
    }
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo and description */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/logo.png" 
                alt="Revolution" 
                className="w-12 h-12"
                onError={(e) => {
                  e.target.src = '/logo.jfif';
                }}
              />
              <h3 className="text-2xl font-bold text-white">Revolution</h3>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Mais do que um clã, somos uma família de guerreiros dedicados à excelência. 
              Junte-se a nós e faça parte da revolução.
            </p>
          </div>

          {/* Footer links */}
          {footerLinks.map((section, index) => (
            <div key={index}>
              <h4 className="text-white font-bold mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {link.to ? (
                      <Link
                        to={link.to}
                        className="hover:text-blue-400 transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        target={"_blank"}
                        href={link.href}
                        className="hover:text-blue-400 transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              © {currentYear} Revolution. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
